import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const EqualSignIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 13.3C3 12.582 3.54323 12 4.21333 12H15.7867C16.4568 12 17 12.582 17 13.3C17 14.018 16.4568 14.6 15.7867 14.6H4.21333C3.54323 14.6 3 14.018 3 13.3Z"
      fill="#080F1D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7.3C3 6.58203 3.54323 6 4.21333 6H15.7867C16.4568 6 17 6.58203 17 7.3C17 8.01797 16.4568 8.6 15.7867 8.6H4.21333C3.54323 8.6 3 8.01797 3 7.3Z"
      fill="#080F1D"
    />
  </SvgIcon>
);

EqualSignIcon.propTypes = {
  sx: PropTypes.object,
};

export default EqualSignIcon;
